import { Header, SearchFilterWrapper, setDateFromStorage } from '@fareye/common'

import { IDateRange } from '@fareye/types'
import { DatePicker, Flex, Grid } from '@fareye/ui'
import {
  currenthhmmA,
  dMmm,
  getQueryParams,
  getSearchFilterFromSession,
  groupBy,
  isEmpty,
  yyyyMmDd
} from '@fareye/utils'
import queryString, { ParsedQuery } from 'query-string'
import React from 'react'
import { mapping } from '../config/mapComponents'

import { IInTransitPerformance } from '../utility/types'

export function MultiModalDetailLayout({
  match,
  config,
  baseUrl,
  history,
  location,
  routesConfig
}: IInTransitPerformance) {
  const searchParams: ParsedQuery<string | Date> = queryString.parse(
    location.search
  )
  const {
    carryDate,
    showDatePicker,
    toggleContent,
    showTimezone
  } = config.config
  const { children, styling, globalSearchPageId } = config
  const { style, className, bodyBgColor, variant, layoutStyle } = styling
  const [globalSearch, setGlobalSearch] = React.useState(
    getSearchFilterFromSession(globalSearchPageId)
  )
  const [searchQuery, setSearchQuery] = React.useState({})
  const filterSelectedKey = toggleContent
    ? toggleContent.filter((item: any) =>
        item.link ? item.link === match.path : true
      )
    : []
  const [selectedKey, setSelectedKey] = React.useState(
    filterSelectedKey.length ? filterSelectedKey[0].selectedKey : ''
  )

  const [lastUpdate, setLastUpdate] = React.useState<string>('')
  const [dateRange, setDateRange] = React.useState(() => {
    return setDateFromStorage({
      showDatePicker: !!showDatePicker,
      carryDate,
      searchParams
    })
  })

  const { startDate, endDate } = dateRange as IDateRange<Date>

  React.useEffect(() => {
    const sq = populateSearchQuery()
    setSearchQuery(sq)
  }, [globalSearch])

  React.useEffect(() => {
    if (showDatePicker) {
      let prevStartDate = searchParams.startDate
      let prevEndDate = searchParams.endDate
      if (prevStartDate !== startDate || prevEndDate !== endDate) {
        const queryParams = getQueryParams({
          ...queryString.parse(location.search),
          startDate,
          endDate
        })
        history.replace({
          pathname: match.url,
          search: queryParams
        })
      }
    }
    setLastUpdate(currenthhmmA())
  }, [dateRange])

  function populateSearchQuery() {
    let searchObj: any = {}
    if (!isEmpty(globalSearch)) {
      const filters = groupBy(globalSearch, 'key')
      Object.keys(filters).forEach((ele: any) => {
        searchObj[ele] = filters[ele].map((item: any) => item.value)
      })
    } else {
      if (!isEmpty(searchQuery)) {
        searchObj = {}
      }
    }
    return searchObj
  }

  function setDateRangeAndStorage(dates: IDateRange<string | Date>) {
    localStorage.setItem('date', JSON.stringify(dates))
    setDateRange(dates as IDateRange<Date>)
  }

  const fileName = (match.params && (match.params as any).id) || 'InTransit'

  return (
    <Flex column width={1} style={{ ...layoutStyle, height: '100%' }}>
      <Header
        match={match}
        toggle={toggleContent}
        lastUpdate={lastUpdate}
        selectedKey={selectedKey}
        setSelectedKey={setSelectedKey}
        startDate={startDate}
        endDate={endDate}
        location={location}
        history={history}
        routesConfig={routesConfig}
        rightTopCorner={
          <Flex>
            {showDatePicker && (
              <DatePicker
                variant="fareyeV2"
                formatter={yyyyMmDd}
                onDateRangeSelected={setDateRangeAndStorage}
                value={dateRange}
              />
            )}
          </Flex>
        }
        showTimezone={showTimezone}
      >
        <Flex column width={1}>
          <Flex justifyContentSpaceBetween>
            <SearchFilterWrapper
              apiFilter={config.filters && (config.filters as any).apiFilter}
              customKeyMapping={(config.filters as any)?.customKeyMapping}
              apiFav={config.filters && (config.filters as any).apiFav}
              pageId="intransit"
              search={globalSearch}
              setSearch={setGlobalSearch}
              startDate={startDate}
              endDate={endDate}
              showTimezone={showTimezone}
            />
          </Flex>
        </Flex>
      </Header>
      <div style={{ flexGrow: 1, background: bodyBgColor }}>
        <Grid
          gridGap={variant.gridGap}
          gridTemplateColumns={variant.gridTemplateColumns}
          style={{ ...style }}
          className={className}
        >
          {Object.entries(children).map(([comp, val]: any) => {
            let ComponentRender: any = (mapping as any)[val.component]
            return (
              <ComponentRender
                key={comp}
                match={match}
                fileName={`${fileName}_${dMmm()}`}
                history={history}
                mapping={mapping}
                location={location}
                setLastUpdate={setLastUpdate}
                searchQuery={searchQuery}
                globalSearch={globalSearch}
                selectedKey={selectedKey}
                endDate={showDatePicker ? endDate : null}
                startDate={showDatePicker ? startDate : null}
                config={(config as any).children[comp]}
              />
            )
          })}
        </Grid>
      </div>
    </Flex>
  )
}
